import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
// import menuIconMobile from '../assets/new-ui/menu-icon-mobile.png'
import menuIconDots from "../assets/new-ui/menu-icon-dots.svg";
import holysharksLogoMobile from "../assets/new-ui/holysharks-logo.png";
import moreArrow from "../assets/new-ui/black-arrow-down.png";
import logo from "../assets/new-ui/holysharks-logo.png";
import connectWalletLogo from "../assets/new-ui/connect-wallet-logo.png";
import {
  checkCorrectNetwork,
  connectMetamask,
  requiredSwitchNetwork,
} from "../utils/connectMetamask";
import { useAddress, useNetwork } from "../contexts/Context";
import { reduceAddressLength } from "../utils/utils";
import ModalOptionConnect from "./ModalOptionConnect";
import ModalSwitchNetwork from "./ModalSwitchNetwork";
import Web3 from "web3";
import { loginAccount } from "../services/api";
import {
  clearLocalData,
  getLocalData,
  setLocalData,
} from "../services/localData";

export default function Menu() {
  const web3 = new Web3(Web3.givenProvider);
  const history = useHistory();
  const [showSubList, setShowSubList] = useState(false);
  const [ethAddress, setEthAddress] = useAddress();
  const [networkId, setNetworkId] = useNetwork();

  const [optionConnectBox, setOptionConnectBox] = useState(false);
  const [switchNetworkBox, setSwitchNetworkBox] = useState(false);
  const [menuListMobile, setMenuListMobile] = useState(false);

  useEffect(() => {
    const token = getLocalData("accessToken");
    if (token) {
      connecWallet();
    }

    if (window.ethereum) {
      window.ethereum.on("networkChanged", function (id: any) {
        if (!checkCorrectNetwork(parseInt(id))) {
          logOut();
          window.location.reload();
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (window.ethereum && ethAddress) {
      window.ethereum.on("accountsChanged", () => {
        logOut();
        window.location.reload();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ethAddress]);

  // useEffect(() => {
  //   console.log(menuListMobile)
  // }, [menuListMobile]);

  useEffect(() => {
    if (ethAddress && checkCorrectNetwork(networkId)) {
      setOptionConnectBox(false);
      setSwitchNetworkBox(false);
      // console.log('connect wallet success')
      const token = getLocalData("accessToken");
      const localAddress = getLocalData("address");
      if (!token) logIn();
      else if (token && localAddress && localAddress !== ethAddress) {
        logOut();
      }
    } else if (ethAddress && !checkCorrectNetwork(networkId)) {
      setOptionConnectBox(false);
      setSwitchNetworkBox(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ethAddress, networkId]);

  async function logIn() {
    signMessage().then((result) => {
      loginAccount(result.message, result.signature).then((result) => {
        if (result.success) {
          setLocalData("accessToken", result.message.accessToken);
          setLocalData("address", ethAddress);
        }
      });
    });
  }

  function signMessage() {
    return new Promise(async (resolve, reject) => {
      try {
        const msg = {
          signerAddress: ethAddress,
          timestamp: Date.now(),
          payload: {},
        };
        const signature = await web3.eth.personal.sign(
          JSON.stringify(msg),
          ethAddress
        );

        resolve({
          message: msg,
          signature: signature,
        });
      } catch (err) {
        reject("user reject");
      }
    });
  }
  function logOut() {
    clearLocalData();
    setEthAddress(null);
    setNetworkId(null);
  }

  function connecWallet() {
    connectMetamask().then((result) => {
      if (result) {
        setEthAddress(result.address);
        setNetworkId(result.network);
      }
    });
  }

  async function checkInstallMetamask() {
    if (!window.ethereum) {
      //not install metamask
      window.open("https://metamask.io/download", "_blank");
    } else if (window.ethereum && !ethAddress) {
      //install metamask but not connect
      setOptionConnectBox(true);
    }
  }

  function switchNetwork() {
    requiredSwitchNetwork().then((result) => {
      setNetworkId(result);
    });
  }

  return (
    <div className="menuContainer">
      <ModalOptionConnect
        toggleModal={optionConnectBox}
        setToggleModal={setOptionConnectBox}
        connectMetamask={connecWallet}
      />

      <ModalSwitchNetwork
        toggleModal={switchNetworkBox}
        switchNetwork={switchNetwork}
      />

      <div
        className="menuMobileContainer"
        onMouseOver={() => {
          setMenuListMobile(true);
        }}
        onMouseOut={() => {
          setMenuListMobile(false);
        }}
      >
        {/* <img src={menuIconMobile} className='menuIconMobile' alt='menu icon' /> */}
        <div className="menuMobile">
          <div>MENU</div>
          <img src={menuIconDots} className="menuIconMobile" alt="menu icon" />
        </div>
        <img
          src={holysharksLogoMobile}
          className="logoIconMobile"
          alt="logo icon"
        />
        <div
          className={menuListMobile ? "menuListMobile" : "menuListMobileHidden"}
        >
          <img src={holysharksLogoMobile} alt="" />
          <div className="list">
            <div className="item" onClick={() => history.push("/")}>
              HOME
            </div>
            <div className="borderGradient" />
            <div
              className="item"
              onClick={() => history.push("/genesis-mystery-box")}
            >
              GENESIS MYSTERY BOX
            </div>
            <div className="borderGradient" />
            <div className="item" onClick={() => history.push("/vision")}>
              OUR VISION
            </div>
            <div className="borderGradient" />
            <div className="item" onClick={() => history.push("/marketplace")}>
              MARKETPLACE
            </div>
            <div className="borderGradient" />
            <div
              className="item"
              onClick={() => history.push("/metaverse-game-play")}
            >
              METAVERSE GAMEPLAY
            </div>
            <div className="borderGradient" />
            <div className="item" onClick={() => history.push("/my-nft")}>
              MY NFTs
            </div>
            <div className="borderGradient" />
            <div className="item" onClick={() => history.push("/auction")}>
              AUCTION
            </div>
            <div className="borderGradient" />
            <div
              className="item"
              onClick={() =>
                window.open(
                  "https://docs.sharktopia.io/?fbclid=IwAR0japrCkiJLfKoPendfMWxPnjOx0pu_WBlxUcfl61t-zUerLtFDGAxGjkw",
                  "_blank"
                )
              }
            >
              WHITE PAPER
            </div>
            <div className="borderGradient" />
            <div className="item" onClick={() => history.push("/gallery")}>
              GALLERY
            </div>
            <div className="borderGradient" />
            <div className="item" onClick={() => history.push("/godly")}>
              GODLY
            </div>
            <div className="borderGradient" />
            <div className="item" onClick={() => history.push("/faq")}>
              FAQ
            </div>
          </div>

          {/* {
            ethAddress
            ? <div className='walletAddress'>{reduceAddressLength(ethAddress)}</div>
            : <CustomButton 
              text={'CONNECT WALLET'} 
              textColor={'black'} 
              fn={() => {setOptionConnectBox(true)}}
              type={'medium'}
              transparent={false}
            />
          } */}
        </div>
      </div>

      <img
        src={logo}
        alt="logo"
        className="menuLogo"
        onClick={() => history.push("/")}
      />

      <div className="menuContent">
        <div className="menuList">
          <div className="menuItem" onClick={() => history.push("/")}>
            HOME
          </div>
          <div
            className="menuItem"
            onClick={() => history.push("/genesis-mystery-box")}
          >
            GENESIS
            <br />
            MYSTERY BOX
          </div>
          <div className="menuItem" onClick={() => history.push("/vision")}>
            OUR VISION
          </div>
          <div
            className="menuItem"
            onClick={() => history.push("/marketplace")}
          >
            MARKETPLACE
          </div>
          <div
            className="menuItem"
            onClick={() => history.push("/metaverse-game-play")}
          >
            METAVERSE
            <br />
            GAMEPLAY
          </div>
          <div
            className="menuItem menuMore"
            onMouseOver={() => {
              setShowSubList(true);
            }}
            onMouseOut={() => {
              setShowSubList(false);
            }}
          >
            MORE <img src={moreArrow} alt="more" />
            <div className={showSubList ? "subList" : "subListHidden"}>
              <div onClick={() => history.push("/my-nft")}>MY NFTs</div>
              <div className="borderGradient" />
              <div onClick={() => history.push("/auction")}>AUCTION</div>
              <div className="borderGradient" />
              <div
                onClick={() =>
                  window.open(
                    "https://docs.holysharks.io/?fbclid=IwAR0japrCkiJLfKoPendfMWxPnjOx0pu_WBlxUcfl61t-zUerLtFDGAxGjkw",
                    "_blank"
                  )
                }
              >
                WHITE PAPER
              </div>
              <div className="borderGradient" />
              <div onClick={() => history.push("/gallery")}>GALLERY</div>
              <div className="borderGradient" />
              <div onClick={() => history.push("/godly")}>GODLY</div>
              <div className="borderGradient" />
              <div onClick={() => history.push("/faq")}>FAQ</div>
            </div>
          </div>
        </div>
        {ethAddress ? (
          <div className="walletAddress">
            {"Address: " + reduceAddressLength(ethAddress)}
          </div>
        ) : (
          <div
            className="connectWalletContainer"
            onClick={() => checkInstallMetamask()}
          >
            <img src={connectWalletLogo} alt="" />
            <div>CONNECT WALLET</div>
          </div>
        )}
      </div>
    </div>
  );
}
